const mutations = {
	setConfigurator(state, { configuratorData }) {
		state.configuratorData = configuratorData;
	},

	setProducts(state, { products }) {
		state.products = products;
	},

	setExtras(state, { extras }) {
		state.extras = extras;
	},

	setUpsells(state, { upsells }) {
		state.upsells = upsells;
	},

	setTestimonials(state, { testimonials }) {
		state.testimonials = testimonials;
	},

	setOrderMessage(state, { message }) {
		return message;
	},

	/**
	 * Adds selected product to order object.
	 * @param {Object} state
	 * @param {Object} payload
	 * @param {Array} payload.productId
	 */
	addProductToOrder(state, { productId }) {
		state.order.product = productId;
	},

	/**
	 *
	 * @param {Object} state
	 * @param {Object} payload
	 * @param {Array} payload.selectedExtras
	 */
	addExtrasToOrder(state, { selectedExtras }) {
		state.order.extras = selectedExtras;
	},

	removeAllExtrasFromOrder(state) {
		state.order.extras = [];
	},

	/**
	 *
	 * @param {Object} state
	 * @param {Object} payload
	 * @param {Array} payload.selectedUpsells
	 */
	addUpsellsToOrder(state, { selectedUpsells }) {
		state.order.upsells = selectedUpsells;
	},

	removeAllUpsellsFromOrder(state) {
		state.order.upsells = [];
	},

	addDetailsToOrder(state, { formData }) {
		state.order.details = { ...state.order.details, ...formData };
	},
};

export { mutations as default };
